import { __ } from '@wordpress/i18n';

function sanitizeIframeSrc( url ) {
	if ( ! url || typeof url !== 'string' ) {
		return '';
	}
	try {
		const parsed = new URL( url.trim() );
		if ( parsed.protocol !== 'http:' && parsed.protocol !== 'https:' ) {
			return '';
		}
		return parsed.toString();
	} catch {
		return '';
	}
}

function sanitizeInlineStyle( css ) {
	if ( ! css || typeof css !== 'string' ) {
		return undefined;
	}
	const lowered = css.toLowerCase();
	if (
		/expression\s*\(|javascript:|@import|\\0|<\s*script/i.test(
			lowered
		)
	) {
		return undefined;
	}
	return css.trim().substring( 0, 600 );
}

function sanitizeSandbox( raw ) {
	if ( ! raw || typeof raw !== 'string' ) {
		return undefined;
	}
	const tokens = raw.trim().replace( /\s+/g, ' ' );
	if ( ! /^[\w\s\-]+$/.test( tokens ) ) {
		return undefined;
	}
	return tokens.substring( 0, 200 );
}



export default function IframeEmbed( {
	height,
	url,
	className,
	threshold = 50,
	live = false,
	iframe_allowfullscreen = false,
	iframe_scrolling = 'no',
	iframe_title = '',
	iframe_id = '',
	iframe_class = '',
	iframe_style = '',
	iframe_name = '',
	iframe_sandbox = '',
} ) {
	const safeUrl = sanitizeIframeSrc( url );
	const isLazy = typeof className === 'string' && className.includes( 'lazy' );
	const iframeClassNames = [
		'wpxero-iframe-embed',
		iframe_class,
		className,
	].filter( Boolean ).join( ' ' );

	const style = sanitizeInlineStyle( iframe_style );
	const sandboxAttr = sanitizeSandbox( iframe_sandbox );

	const accessibleTitle =
		iframe_title && iframe_title.trim()
			? iframe_title.trim()
			: __( 'Embedded iframe content', 'wpxero-iframe' );

	const iframeProps = {
		className: iframeClassNames,
		width: '100%',
		height,
		allowFullscreen: iframe_allowfullscreen,
		referrerPolicy: 'strict-origin-when-cross-origin',
	};

	if ( iframe_id ) {
		iframeProps.id = iframe_id.replace( /[^\w\-]/g, '' ).substring( 0, 80 );
	}
	if ( iframe_name ) {
		iframeProps.name = iframe_name
			.replace( /[^\w\-]/g, '' )
			.substring( 0, 120 );
	}
	if ( style ) {
		iframeProps.style = style;
	}
	if ( sandboxAttr !== undefined ) {
		iframeProps.sandbox = sandboxAttr;
	}
	if ( iframe_scrolling ) {
		iframeProps.scrolling = iframe_scrolling;
	}

	const liveAttr =
		live === true ||
		live === 'true' ||
		live === 1 ||
		live === '1';
	const thresholdPx =
		typeof threshold === 'number' ? threshold : parseInt( threshold, 10 ) || 50;

	return (
		<iframe
			title={ accessibleTitle }
			{ ...iframeProps }
			src={ isLazy ? 'about:blank' : safeUrl || 'about:blank' }
			data-src={ isLazy ? safeUrl : undefined }
			data-threshold={ isLazy ? String( thresholdPx ) : undefined }
			data-live={ liveAttr ? '1' : undefined }
			loading={ isLazy ? 'lazy' : 'eager' }
		/>
	);
}
